var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "KioskCenteredLayout",
    { class: _vm.$style.discountPageWrapper },
    [
      _vm.discountCodeIsUpdating ? _c("KioskSpinner") : _vm._e(),
      _vm._v(" "),
      _c("KioskMessageTitle", {
        class: _vm.$style.discountTitle,
        attrs: { title: "Discount Code" }
      }),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.$style.discount },
        [
          _c("InputField", {
            class: _vm.getStyle,
            attrs: { type: "text" },
            model: {
              value: _vm.$v.text.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.text, "$model", $$v)
              },
              expression: "$v.text.$model"
            }
          }),
          _vm._v(" "),
          _vm.$v.text.$error
            ? _c("p", { class: _vm.$style.errorMessage }, [
                _vm._v("\n      Please, enter discount code.\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.discountErrors.length
            ? _c(
                "div",
                _vm._l(_vm.discountErrors, function(error, index) {
                  return _c(
                    "p",
                    { key: index, class: _vm.$style.errorMessage },
                    [_vm._v("\n        " + _vm._s(error) + "\n      ")]
                  )
                }),
                0
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.$style.discountButtons },
        [
          _c(
            "BaseButton",
            {
              class: _vm.$style.cancelBtn,
              attrs: { disabled: _vm.discountCodeIsUpdating },
              on: { click: _vm.cancel }
            },
            [
              _c("svg", {
                directives: [{ name: "svg", rawName: "v-svg" }],
                class: _vm.$style.cancelIcon,
                attrs: { symbol: "remove-icon-kiosk" }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "BaseButton",
            {
              class: _vm.$style.submitBtn,
              attrs: { disabled: _vm.discountCodeIsUpdating },
              on: { click: _vm.checkDiscount }
            },
            [
              _c("svg", {
                directives: [{ name: "svg", rawName: "v-svg" }],
                class: _vm.$style.submitIcon,
                attrs: { symbol: "check-icon-kiosk" }
              })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.$style.discountBottom },
        [
          _c("Keyboard", {
            attrs: { disabled: _vm.discountCodeIsUpdating },
            model: {
              value: _vm.$v.text.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.text, "$model", $$v)
              },
              expression: "$v.text.$model"
            }
          }),
          _vm._v(" "),
          _c("KioskTryBlock")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/kiosk/components/KioskDiscount.vue?vue&type=template&id=117ed14b&
// module id = null
// module chunks = 